import { Injectable } from '@angular/core';

@Injectable()
export class CssClassUtils {
    private cssRowColorArray: Array<string> = new Array<string>();
    private cssRowCharacterColorMap: Map<string, string> = new Map<string, string>(
        [
            ['dp_color2', 'badge_blue'],
            ['color_pale_green', 'badge_green'],
            ['dp_color1', 'badge_red'],
            ['color_pale_blue', 'badge_cyan'],
            ['color_pale_rose', 'badge_orange'],
            ['dp_color5', 'badge_dark_green'],
            ['dp_color8', 'badge_dark_blue']
        ]
    );


    constructor() {
        this.cssRowColorArray = this.getRestoreCssColorArray();
    }

    private getRestoreCssColorArray(): Array<string> {
        return new Array<string>(
            'dp_color2',
            'color_pale_green',
            'dp_color1',
            'color_pale_blue',
            'color_pale_rose',
            'dp_color5',
            'dp_color8'
        );
    }

    public getRowColorCSSClass( index: number ): string {
        return this.cssRowColorArray[( index % this.cssRowColorArray.length )];
    }

    public getRowCharacterCSSClass( index: number ): string {
        return this.cssRowCharacterColorMap.get( this.cssRowColorArray[( index % this.cssRowColorArray.length )] );
    }

}
